"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareAccountInfo = void 0;
var _formatString = require("../../../utils/formatString");
const prepareAccountInfo = _ref => {
  let {
    publishedAnnouncementsCount,
    lastActivityDate
  } = _ref;
  const result = [];
  if (lastActivityDate) {
    result.push(`Последний раз заходили ${lastActivityDate}`);
  }
  if (publishedAnnouncementsCount) {
    result.push(publishedAnnouncementsCount);
  }
  return (0, _formatString.firstLetterToUppercase)(result.join(', '));
};
exports.prepareAccountInfo = prepareAccountInfo;